'use client';

import { useStyle } from '@/classify';
import { useSignInPage } from '@/hooks/SignInPage/useSignInPage';
import Image from 'next/image';
import SignIn from '../SignIn';
import defaultClasses from './signInPage.module.css';
const SignInPage = props => {
  const classes = useStyle(defaultClasses, props.classes);
  const { signInProps } = useSignInPage(props);
  const { showCreateAccount } = signInProps;

  return (
    <div className=''>
      {/* <div className={classes.blocktitle}>
        <h1 className={[classes.header, classes.active].join(' ')}>
          <FormattedMessage
            id='signInPage.logintitle'
            defaultMessage='LOGIN'
          />
        </h1>
        <h2
          className={classes.header}
          onClick={showCreateAccount}
        >
          <FormattedMessage
            id='signInPage.registertitle'
            defaultMessage='REGISTER'
          />
        </h2>
      </div> */}
      <Image
        src='/signIn.jpg'
        alt='affiliate-program'
        width={3840}
        height={740}
        className='hidden w-full object-cover lg_block lg_min-h-[370px]'
      />
      <div className='personalContent mx-auto py-[40px] lg_pb-[80px] lg_pt-[60px]'>
        <SignIn
          {...signInProps}
          className='w-full lg_w-full'
        />
      </div>
    </div>
  );
};

export default SignInPage;
